(ns story-builder.story-editor.scene-control.util
  (:require [clojure.string :as str]
            [story-builder.story-editor.breakpoint.util :as breakpoint.util]
            [story-builder.story-editor.interactive.util :as interactive.util]
            [story-builder.util.core :as util]))

(defn stretched-to-fit?
  [layer active-breakpoints]
  (let [layer-classes (breakpoint.util/get-props layer active-breakpoints :layer-classes)]
    (or (and (= (get layer-classes :background) "is-fit")
             (nil? (breakpoint.util/get-props layer active-breakpoints :fill))) ; Deprecated way.
        (= (breakpoint.util/get-props layer active-breakpoints :fill) :contain))))

(defn stretched-to-fill?
  [layer active-breakpoints]
  (let [style (breakpoint.util/get-props layer active-breakpoints)]
    (or (and (not (stretched-to-fit? layer active-breakpoints))
             (= (get style :width) "100%")
             (= (get style :height) "100%")
             (nil? (breakpoint.util/get-props layer active-breakpoints :fill))) ; Deprecated way.
        (= (breakpoint.util/get-props layer active-breakpoints :fill) :cover))))

(defn background?
  [layer active-breakpoints]
  (or (stretched-to-fit? layer active-breakpoints)
      (stretched-to-fill? layer active-breakpoints)))

(defn stretched-horizontally?
  [layer active-breakpoints]
  (let [layer-classes (breakpoint.util/get-props layer active-breakpoints :layer-classes)
        fill          (breakpoint.util/get-props layer active-breakpoints :fill)]
    (or (stretched-to-fit? layer active-breakpoints)
        (stretched-to-fill? layer active-breakpoints)
        (contains? #{:contain :cover :horizontal} fill)
        (and (nil? fill) (= (get layer-classes :width) "is-fullW")))))

(defn stretched-vertically?
  [layer active-breakpoints]
  (let [layer-classes (breakpoint.util/get-props layer active-breakpoints :layer-classes)
        fill          (breakpoint.util/get-props layer active-breakpoints :fill)]
    (or (stretched-to-fit? layer active-breakpoints)
        (stretched-to-fill? layer active-breakpoints)
        (contains? #{:contain :cover :vertical} fill)
        (and (nil? fill) (= (get layer-classes :height) "is-fullH")))))

(defn orderable-layer? [layer]
  (contains? (into #{"img" "video" "shape" "overlay" "embed" "product-tag"
                     "text" "title" "author" "date" "subheading" "rich-text" "captions"
                     "reveal" "scratch" "slideshow"}
                   interactive.util/interactive-layer-types)
             (:type layer)))

(defn orderable-layers [layers]
  (->> layers
       (filterv orderable-layer?)))

(defn unused-top-value
  "Returns the smallest 'top' value multiple of 10 and above 0 which is not
   already used by the existing text layers."
  [text-layers active-breakpoints]
  (let [already-used-values (into #{}
                                  (keep (fn [text-layer]
                                          (try
                                            (let [style (breakpoint.util/get-props text-layer active-breakpoints)]
                                              (-> (get style :top)
                                                  (str/replace "%" "")
                                                  js/parseFloat
                                                  (util/round 10)))
                                            (catch :default _ nil))))
                                  text-layers)]
    (->> (range 10 100 10) ;; 10 20 ... 90
         (sort-by #(js/Math.abs (- 50 %)))
         (remove already-used-values)
         first)))

(defn new-top-z-index [layers]
  (let [max-z-index (->> layers
                         (map #(get-in % [:style :z-index]))
                         (apply max))]
    (max 2 (some-> max-z-index inc))))